export enum CommitmentTypes {
  Manager = 'manager',
  PBM = 'hp',
  Partner = 'partner',
}

export enum CommitmentStatusKeys {
  Dropped = 'jbp-commitment-status-dropped',
}

export enum AcknowledgmentAction {
  Remove = 'remove',
  Drop = 'drop',
  SignOff = 'signOff',
  Change = 'change',
  Select = 'select',
  Refuse = 'refuse',
  Resend = 'resend',
  Add = 'add',
  SignOffAll = 'signOffAll',
}
